<h2 *ngIf="(maxNumberOfPersons$ | async) === 1; else multiple" class="mbottom-12">
  {{ 'commercialCheckout.personalization.createPerson.titleSinglePerson' | transloco }}
</h2>
<ng-template #multiple>
  <h2 class="mbottom-12">
    {{ 'commercialCheckout.personalization.createPerson.title' | transloco }}
  </h2>
</ng-template>
<div class="container p-0">
  <form [formGroup]="createPersonForm" (yatSubmit)="submitForm($event)">
    <div *ngIf="(mustIncludeUser$ | async) === false" class="row">
      <div class="col-12 mb-[12px]">
        <yat-toggle
          leftLabel="{{ 'commercialCheckout.personalization.createPerson.personForm.tabControl.me' | transloco }}"
          rightLabel="{{ 'commercialCheckout.personalization.createPerson.personForm.tabControl.someoneElse' | transloco }}"
          (toggleChanged)="toggleChanged($event)"
          [selectedValue]="createPersonForm.controls.isUser.value ? 'left' : 'right'"
          variant="tabs"></yat-toggle>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <yat-form-group labelFor="first-name" [label]="'firstName.label' | commonUserProfileWording | async" [optional]="false">
          <input id="first-name" formControlName="firstName" maxlength="125" yatInput #firstNameInput />
          <div class="invalid-feedback" [ngSwitch]="createPersonForm.controls.firstName.errors | classifyValidationError">
            <span *ngSwitchCase="'required'">{{ 'firstName.validators.required' | commonUserProfileWording | async }}</span>
          </div>
        </yat-form-group>
      </div>
      <div class="col-12">
        <yat-form-group labelFor="last-name" [label]="'lastName.label' | commonUserProfileWording | async" [optional]="false">
          <input id="last-name" formControlName="lastName" maxlength="125" yatInput #lastNameInput />
          <div class="invalid-feedback" [ngSwitch]="createPersonForm.controls.lastName.errors | classifyValidationError">
            <span *ngSwitchCase="'required'">{{ 'lastName.validators.required' | commonUserProfileWording | async }}</span>
          </div>
        </yat-form-group>
      </div>
      <div class="col-6" *ngIf="birthDateRequired">
        <yat-form-group labelFor="birth-date" [label]="'birthDate.label' | commonUserProfileWording | async" [optional]="false">
          <yat-date-input id="birth-date" formControlName="birthDate" yatInput [isInvalid]="createPersonForm.get('birthDate')?.invalid"></yat-date-input>
          <div class="invalid-feedback" [ngSwitch]="createPersonForm.controls.birthDate.errors | classifyValidationError">
            <span *ngSwitchCase="'required'">{{ 'birthDate.validators.required' | commonUserProfileWording | async }}</span>
            <span *ngSwitchCase="'invalidDate'">{{ 'birthDate.validators.invalidDate' | commonUserProfileWording | async }}</span>
            <span *ngSwitchCase="'oldHuman'">{{ 'birthDate.validators.oldHuman' | commonUserProfileWording | async }}</span>
            <span *ngSwitchCase="'futureDate'">{{ 'birthDate.validators.futureDate' | commonUserProfileWording | async }}</span>
          </div>
        </yat-form-group>
      </div>
    </div>

    <div *ngIf="addressRequirements">
      <h2 class="mbottom-12">
        {{ 'commercialCheckout.personalization.createPerson.titleAddress' | transloco }}
      </h2>
      <div class="flex">
        <div *ngIf="addressRequirements.countryRequired" class="col-6 pl-0">
          <yat-form-group labelFor="country-select" [label]="'commercialCheckout.personalization.createPerson.country.label' | transloco" [optional]="false">
            <yat-country-select id="country-select" ngDefaultControl [formControl]="createPersonForm.controls.country" yatInput> </yat-country-select>
          </yat-form-group>
        </div>
        <div *ngIf="isZipCodeRequiredForCountry(createPersonForm.controls.country.value)" class="col-6 pl-0 pr-0">
          <yat-form-group labelFor="zip-code" [label]="'commercialCheckout.personalization.createPerson.zipCode.label' | transloco">
            <input
              type="text"
              inputmode="numeric"
              pattern="[0-9\s\-]*"
              autocomplete="postal-code"
              class="form-control"
              id="zip-code"
              formControlName="zipCode"
              oninput="value=value.replace(/[^0-9]/g,'')"
              yatInput />
            <div class="invalid-feedback" [ngSwitch]="createPersonForm.controls.zipCode.errors | classifyValidationError">
              <span *ngSwitchCase="'required'">{{ 'commercialCheckout.personalization.createPerson.zipCode.validators.required' | transloco }}</span>
              <span *ngSwitchCase="'invalidZipCode'">{{
                'commercialCheckout.personalization.createPerson.zipCode.validators.invalidZipCode' | transloco
              }}</span>
            </div>
          </yat-form-group>
        </div>
      </div>
    </div>

    <yat-buttons
      [primaryButtonName]="('saveAndContinue' | commonWording | async) ?? ''"
      [useYatAutoSpinner]="setFirstPersonActionFilter"
      [secondaryButtonName]="('back' | commonWording | async) ?? ''"
      (secondaryButtonClickMethod)="cancel()"
      [className]="'btn-large'">
    </yat-buttons>
  </form>
</div>
<div class="mt-3 text-center text-n-40" *ngIf="createPersonForm.controls.isUser.value">
  {{ 'commercialCheckout.personalization.createPerson.privacyNote' | transloco }}
</div>
